/**
 * The page between the chair and round 1 (chair DESIGN §6): the bank as it is handed over, on its standing policy, with the three figures the player
 * starts from and one primary button. Reached from "Ready for Round 1" and "Skip the practice"; nothing here saves anything.
 */
import type { TeamState } from "@bsim/contracts";
import { TWIN_DEFINITION } from "@gxs/metric-defs";
import { formatKpi } from "../format";
import { kpiLabel } from "../format/labels";

export function RoundOneIntro({ team, onBegin, onBack }: { readonly team: TeamState; readonly onBegin: () => void; readonly onBack: () => void }) {
  const start = team.kpiHistory.find((h) => h.roundNo === 0)?.kpis ?? team.kpiHistory[0]?.kpis ?? {};
  const statement = (team.strategyStatement?.text ?? "").trim();
  // The same names the chair's start table uses one step earlier.
  const facts = ["price", "cet1Reported", "nim"] as const;
  return (
    <section className="gx-hero gx-on-navy gx-chair-intro-card" data-testid="chair.intro">
      <div>
        <div className="gx-eyebrow">Before round 1</div>
        <h2 className="gx-chair-intro-h">Your bank, on its standing policy</h2>
        <p className="gx-chair-intro-lead">Round 1 starts from the policy your bank already runs. You decide what to change, one desk at a time.</p>
        <div className="gx-chair-facts gx-num">
          {facts.map((k) => <div key={k}><b>{start[k] === undefined ? "n/a" : formatKpi(k, start[k] ?? 0)}</b><span>{kpiLabel(k)}</span></div>)}
        </div>
        <p className="gx-hero-sub">Your status-quo twin starts from the same place. {TWIN_DEFINITION}</p>
        <p className="gx-chair-intro-strategy" data-testid="chair.intro.strategy">{statement === "" ? "No strategy sentence yet. You can add one from the Decide page." : `“${statement}”`}</p>
        <div className="gx-chair-intro-acts">
          <button type="button" className="gx-btn gx-btn--accent gx-btn--lg" data-testid="chair.intro.begin" onClick={onBegin}>Begin Round 1</button>
          <button type="button" className="gx-btn gx-btn--onnavy" data-testid="chair.intro.back" onClick={onBack}>Back to the practice quarter</button>
        </div>
      </div>
    </section>
  );
}
